import { render } from "./topMenuList.vue?vue&type=template&id=46b37296&scoped=true"
import script from "./topMenuList.vue?vue&type=script&lang=js"
export * from "./topMenuList.vue?vue&type=script&lang=js"

import "./topMenuList.vue?vue&type=style&index=0&id=46b37296&scoped=true&lang=scss"

import exportComponent from "/builds/playmob1/songreach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b37296"]])

export default __exports__